module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "kbx-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.placeholderText
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a1e7b20a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/text/Input.vue
 ** module id = 892
 ** module chunks = 1
 **/